import React from "react";
import "./ContactUsIcons.css";


const ContactUsIcons = React.memo(props => {
    let engContactForm = props.lang==='en';
     return (
        <React.Fragment>
            <div className={engContactForm?"iconWrap iconWrapEn": "iconWrap"}>
                <img src="/_layouts/15/images/sites/Museums/ContactUs/facebook.png" />
                <a className="bold" href={props.items.MODSiteFacebook} title="facebook">{engContactForm?"Facebook":"בפייסבוק"}</a>
            </div>
            <div className={engContactForm?"iconWrap iconWrapEn": "iconWrap"}>
                <img src="/_layouts/15/images/sites/Museums/ContactUs/Instagram.png" />
                <a className="bold" href={props.items.MODSiteInstgram} title="Instagrem">{engContactForm?"Instagram":"באינסטגרם"}</a>
            </div>
            <div className={engContactForm?"iconWrap iconWrapEn": "iconWrap"}>
                <div className="flex">
                    <img src="/_layouts/15/images/sites/Museums/ContactUs/mail.png" />
                </div>
                <div className="flex column">
                    <div className="top15">{engContactForm?"Mail:":'בדוא"ל'}</div>
                    <div><a href={"mailto:"+props.items.MODSiteMail} title={props.items.MODSiteMail}>{props.items.MODSiteMail}</a></div>
                </div>
             </div>
             <div className={engContactForm?"iconWrap iconWrapEn": "iconWrap"}>
                <div className="flex">
                    <img src="/_layouts/15/images/sites/Museums/ContactUs/phone.png" />
                </div>
                <div className="flex column">
                    <div className="top15">{engContactForm?"Tel:":"בטלפון:"}</div>
                    <div>
                        <div className="hidden-md-down">{props.items.MODPhone1}</div>
                        <a  className="hidden-lg-up" href={"tel:"+props.items.MODPhone1} title={props.items.MODPhone1}>{props.items.MODPhone1}</a>
                    </div>
                 </div>
            </div>
            <div className={engContactForm?"iconWrap iconWrapEn": "iconWrap"}>
                <div className="flex">
                    <img src="/_layouts/15/images/sites/Museums/ContactUs/fax.png" />
                </div>
                <div className="flex column">
                    <div className="top15">{engContactForm?"Fax:":"בפקס:"}</div>
                    <div>
                        <div>{props.items.MODFax}</div>
                    </div>
                 </div>
            </div>
            <div className={engContactForm?"iconWrap iconWrapEn": "iconWrap"}>
                <div className="flex">
                    <img src="/_layouts/15/images/sites/Museums/ContactUs/address.png" />
                </div>
                <div className="flex column">
                    <div className="top15">{engContactForm?"Adrress:":"בכתובת:"}</div>
                    <div>
                        <a className="adrressAItem" href={props.items.MODNav_Url} title={props.items.ModFooterAddress} dangerouslySetInnerHTML={{__html: props.items.ModFooterAddress}}></a>
                    </div>
                 </div>
            </div>

        </React.Fragment>
    );
});
export default ContactUsIcons;